import React from "react";
import './HydroponicFarming.css';
import SearchBar from "../Search/SearchBar";

const HydroponicFarming = () => {
  return (
    <>
     <section className="verticalFarming">
            <div className="verticalFarmingHero">
                  <div className="searchBarWrapper">
                  <SearchBar />
                  </div>
              <h3 className="heroTitle">FARMING TECHNIQUES</h3>
            </div>
            <div className="verticalFarmingContent">
                  <h3>Hydroponic Farming</h3>
                  <h4>What is Hydroponic Farming?</h4>
                  <p className="paragraphWrapper">
                  Hydroponic farming often referred to as hydro farming, is a method of growing plants without soil, using mineral nutrient solutions in a water solvent. The roots of the plants are submerged in the nutrient solution, or they may be supported by an inert medium such as perlite, rockwool, or gravel.
                  </p>
                  <p className="paragraphWrapper">
                  Hydroponic systems can vary widely in design, from simple systems like nutrient film technique (NFT) or deep water culture (DWC) to more complex setups such as aeroponics or aquaponics. In hydroponic farming, growers have precise control over the nutrient levels, pH, and environmental conditions, allowing for optimal plant growth and yields.
                  </p>
                  <div className="verticalFarmImage">
                        <img src="/FrameHome.png" alt="farming" />
                  </div>
                  <h4>Advantages of Hydroponic Farming</h4>
                  <p className="paragraphWrapper"> Hydroponic Farming has several advantages:</p>
                  <ol className="ordListscolor">
                        <li>Faster Growth Rate</li>
                        <li>Higher Yields</li>
                        <li>Efficient use of water and space</li>
                        <li>Hydroponic systems can also be set up in areas where traditional soil-based agriculture is not suitable, such as urban environments or arid regions.</li>
                  </ol>

                  <h4>Types of Plants and Methods of Growing them Using Hydro Farming</h4>
                  <ol className="ordLists">
                        <li>Vegetables</li>
                        <li>Grains</li>
                        <li>Tuber</li>
                  </ol>
                  <div className="vegetable">
                <h4>1. VEGETABLES</h4>
                <p className="paragraphWrapper">
                Hydroponic farming offers several methods for growing vegetables, each with its own pre-planting, planting, and post-planting techniques. Here are some common methods:
                </p>
                <ol className="ordLists">
                  <li>
                    <span className="ordListsSub">Nutrient Film Technique (NFT)</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Pre-planting:</span> Set up the NFT channels or gutters, ensuring they are level and securely supported. Prepare the nutrient solution according to the specific requirements of the vegetables being grown.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Planting:</span> Insert seedlings or young plants into the holes or slots in the NFT channels, ensuring that the roots are in contact with the flowing nutrient solution.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Post-planting:</span> Monitor the nutrient solution levels and pH regularly, adjusting as needed. Prune plants as they grow to maintain optimal spacing and airflow.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span  className="ordListsSub">Deep Water Culture (DWC) </span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Pre-planting:</span> Prepare the DWC reservoir by filling it with the nutrient solution and ensuring proper aeration with an air pump and airstones.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Planting:</span> Place net pots or baskets containing seedlings or young plants into the holes in the lid of the DWC reservoir, ensuring that the roots are submerged in the nutrient solution.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Post-planting:</span> Monitor the nutrient solution levels and oxygenation regularly, adjusting the pH and adding nutrients as needed. Trim roots periodically to prevent them from becoming tangled or clogged.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <span  className="ordListsSub">Drip Irrigation</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Pre-planting:</span> Set up the drip irrigation system, including drip lines, emitters, and a reservoir for the nutrient solution. Ensure that the system is properly calibrated to deliver the correct amount of water and nutrients to each plant.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Planting:</span> Plant seedlings or young plants into a growing medium such as perlite, rockwool, or coconut coir within pots or trays. Place the pots or trays beneath the drip lines.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Post-planting:</span> Monitor the drip system regularly to ensure that each plant is receiving adequate moisture and nutrients. Adjust the drip emitters as needed to prevent overwatering or underwatering.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <span  className="ordListsSub">Vertical Farming</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Pre-planting:</span> Install vertical growing towers or shelves in a well-lit indoor space. Set up a recirculating hydroponic system with a reservoir for the nutrient solution.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Planting:</span> Plant seedlings or young plants into growing pockets or containers attached to the vertical structures, ensuring that the roots have access to the nutrient solution.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Post-planting:</span> Monitor the plants closely for signs of nutrient deficiencies or overgrowth. Rotate the towers or shelves regularly to ensure even exposure to light and airflow.
                      </li>
                    </ul>
                  </li>
                </ol>

                <div className="verticalFarmImage1">
                  <img src="/FrameHome.png" alt="farming" />
                  <img src="/AboutUs3.png" alt="farming" />
                </div>
                
                <p className="moreExplanations">
                Regardless of the specific hydroponic method used, it's essential to monitor environmental conditions such as temperature, humidity, and light intensity throughout the growing cycle. Additionally, regular maintenance tasks such as cleaning, pruning, and pest management are crucial for maximizing yields and ensuring the health of the vegetable crops.
                </p>
              </div>

              <div className="grains">
                <h4>2. GRAINS</h4>
                <p className="paragraphWrapper">
                Growing grains hydroponically presents some challenges due to their larger root systems and longer growth cycles compared to vegetables. However, it's still feasible with proper planning and execution. Here are pre-planting, planting, and post-planting methods for grains using hydro farming:
                </p>
                <ol className="ordLists">
                  <li>
                  <span className="ordListsSub">Pre-Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Choose a suitable hydroponic system:</span> While most hydroponic systems can be adapted for grain cultivation, systems that provide ample space for root growth and support for taller plants are preferable.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Select appropriate grain varieties:</span> Some grains, such as wheat, barley, and rice, are better suited for hydroponic cultivation due to their relatively compact root systems and adaptability to soilless growing conditions.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Prepare nutrient solution:</span> Grain crops require a balanced nutrient solution that provides essential macronutrients (nitrogen, phosphorus, potassium) and micronutrients. Prepare the nutrient solution according to the specific requirements of the chosen grain varieties.
                      </li>
                      <li>
                      <span className="paragraphSubHead">d. Ensure adequate lighting:</span> Grain crops require sufficient light for photosynthesis. Supplemental lighting may be necessary, especially if growing grains indoors or in low-light environments.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <span  className="ordListsSub">Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Germination:</span> Start by germinating grain seeds using the appropriate method for each grain variety. This may involve soaking seeds in water for a period of time until they sprout.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Planting medium:</span> Use a suitable planting medium that provides support for the germinating seeds and allows for adequate root aeration. Options include rockwool cubes, perlite, or coco coir.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Planting technique:</span> Place germinated seeds into the planting medium, ensuring proper spacing between seeds to prevent overcrowding. Cover the seeds lightly with the planting medium.
                      </li>
                      <li>
                      <span className="paragraphSubHead">d. Placement in hydroponic system:</span> Depending on the chosen hydroponic system, place the planting trays or containers containing the germinated seeds into the system. Ensure that the roots have access to the nutrient solution.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <span  className="ordListsSub">Post-Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Nutrient Management:</span> Monitor the nutrient solution regularly to maintain proper nutrient levels and pH. Adjust the nutrient solution as needed to meet the changing needs of the growing grain crops.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Water Management:</span> Ensure that the hydroponic system provides adequate water to the growing grain plants while preventing waterlogging or drought stress. Monitor water levels and irrigation frequency closely.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Structural Support:</span> As grain plants grow taller, provide adequate support to prevent lodging (falling over) and ensure optimal growth. This may involve installing trellises or other support structures within the hydroponic system.
                      </li>
                      <li>
                      <span className="paragraphSubHead">d. Harvesting:</span> Grain crops are typically harvested when the seeds have matured and reached the desired moisture content. Harvesting methods vary depending on the grain variety and can involve cutting the stalks and threshing to remove the seeds.
                      </li>
                    </ul>
                  </li>
                </ol>

                {/*<div className="verticalFarmImage1">
                  <img src="/Grain vertical.png" alt="farming" />
                  <img src="/Grain 2.png" alt="farming" />
                  </div>*/}
                
                <p className="moreExplanations">
                Overall, successful hydroponic grain cultivation requires attention to detail throughout the growing process, from pre-planting preparations to post-planting care and harvesting. With proper planning and management, hydroponic systems can produce healthy and productive grain crops.
                </p>
              </div>
              <div className="tuber">
                <h4>3. TUBER</h4>
                <p className="paragraphWrapper">
                Growing tubers, such as potatoes or sweet potatoes, using hydroponic methods can be challenging due to their below-ground growth habit and need for ample space for tuber development. However, it's possible with some adaptations to traditional hydroponic techniques. Here's a guide to pre-planting, planting, and post-planting methods for tubers using hydro farming:
                </p>

                <ol className="ordLists">
                  <li>
                  <span className="ordListsSub">Pre-Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Choose suitable tuber varieties:</span> Select tuber varieties that are well-suited for hydroponic cultivation, such as smaller or compact varieties that produce higher yields in confined spaces.
                      </li>
                      <li>
                        <span className="paragraphSubHead">b. Prepare the hydroponic system:</span> Set up the hydroponic system with consideration for the space required for tuber growth. Deep water culture (DWC) or nutrient film technique (NFT) systems with ample root space are suitable options.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Prepare the nutrient solution:</span> Tubers require a balanced nutrient solution rich in potassium and phosphorus to support tuber formation. Prepare the nutrient solution according to the specific requirements of tuber crops.
                      </li>
                      <li>
                      <span className="paragraphSubHead">d. Germination:</span> Begin by sprouting tuber seeds or seed potatoes using traditional methods such as chitting. This involves allowing the tubers to develop small sprouts before planting.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <span  className="ordListsSub">Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Planting medium:</span> Use a suitable planting medium that provides support for tuber development while allowing for proper root aeration. Options include perlite, coco coir, or a mix of perlite and vermiculite.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Planting technique:</span> Place sprouted tuber seeds or seed potatoes into the planting medium, ensuring that the sprouts are facing upward and the tubers are partially buried. Space the tubers according to the recommended planting density for the chosen variety.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Placement in hydroponic system:</span> Plant the tubers in containers or growing trays within the hydroponic system, ensuring that the roots have access to the nutrient solution. If using a DWC system, suspend the tubers above the nutrient solution using mesh pots or net cups.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <span  className="ordListsSub">Post-Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Nutrient Management:</span> Monitor the nutrient solution regularly to ensure that tuber crops receive adequate nutrients throughout their growth cycle. Adjust the nutrient solution as needed to maintain optimal nutrient levels and pH.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Water Management:</span> Maintain proper water levels in the hydroponic system to prevent waterlogging or drought stress. Monitor water levels closely, especially during tuber development, to ensure consistent moisture.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Structural Support:</span> Provide support for the growing tuber plants to prevent lodging and ensure optimal growth. As tubers develop, additional support may be needed to prevent the weight of the tubers from bending or breaking the stems.
                      </li>
                      <li>
                      <span className="paragraphSubHead">d. Harvesting:</span> ubers are typically harvested when they reach maturity and have developed to the desired size. Harvesting methods vary depending on the tuber variety and may involve gently digging up the tubers from the planting medium.
                      </li>
                    </ul>
                  </li>
                </ol>

                {/*<div className="verticalFarmImage1">
                  <img src="/tuber verticall 1.png" alt="farming" />
                  <img src="/Vertical Tuber 1.png" alt="farming" />
                </div>*/}
                
                <p className="moreExplanations">
                By following these pre-planting, planting, and post-planting methods, it's possible to grow tubers successfully using hydroponic techniques. While it may require some experimentation and adaptation, hydroponic tuber cultivation can yield healthy and productive crops in controlled environments.
                </p>
              </div>
            </div>
      </section>
    </>
  )
};

export default HydroponicFarming;